<template>
	<div class="event-milestones-reward">
		<Tooltip
			v-if="reward.type === MilestoneRewardType.CURRENCY"
			:placement="Placements.TOP"
		>
			<template #element>
				<AppPrice
					:amount="getAmount(reward.amount)"
					:currency="reward?.currency"
					:resourceCheck="false"
					:fontSize="19"
					:iconSize="20"
				/>
			</template>
			<template #tooltip>
				<span>
					{{ translate(`resource.${reward.currency}`) }}
				</span>
			</template>
		</Tooltip>
		<Tooltip
			v-if="reward.type === MilestoneRewardType.ITEM"
			:heading="translate(`${reward.frameName}.name`)"
			customWidth="18rem"
			:placement="Placements.TOP"
		>
			<template #element>
				<AppItemAmount
					:amount="reward.amount as number"
					:frameName="
						(reward as MilestoneInGameRewardBuilding).frameName
					"
					:iconSize="24"
				/>
			</template>
			<template #tooltip>
				<span class="milestone-tooltip__content">
					<p
						v-html="
							buildingEntity?.description.replace(/\{\/?b\}/g, '')
						"
					/>
					<TileAggregationDetails
						v-if="buildingEntity"
						:entity="buildingEntity"
						:isPromotion="true"
					/>
				</span>
			</template>
		</Tooltip>
	</div>
</template>

<script lang="ts" setup>
import AppPrice from "@/components/AppPrice.vue";
import Tooltip from "@/components/Tooltip.vue";
import {
	MilestoneRewardType,
	type MilestoneInGameRewardBuilding,
	type MilestoneInGameRewardCurrency,
} from "@/types/event";

import type TileEntity from "@/game/entities/TileEntity.ts";
import useTileRepository from "@/hooks/useTileRepository.ts";
import { Placements } from "@/types/ui";
import { getAmount } from "@/utils/number";
import { translate } from "@/utils/translate";
import { computed, markRaw } from "vue";
import AppItemAmount from "../AppItemAmount.vue";
import TileAggregationDetails from "../TileAggregationDetails.vue";

interface Props {
	reward: MilestoneInGameRewardCurrency | MilestoneInGameRewardBuilding;
}

const { reward } = defineProps<Props>();
const tilerepo = markRaw(useTileRepository());
const buildingEntity = computed((): TileEntity | null => {
	return tilerepo.createEntityByFrameName(
		(reward as MilestoneInGameRewardBuilding).frameName,
	);
});
</script>
<style lang="scss" scoped>
.event-milestones-reward {
	pointer-events: auto;
}
</style>
